import _ from 'lodash'

class SubscriptionService {
  constructor(Subscription, AddOns, Plans, Datasets, CurrentUserService, $q) {
    this.Subscription = Subscription
    this.AddOns = AddOns
    this.Plans = Plans
    this.Datasets = Datasets
    this.CurrentUserService = CurrentUserService
    this.$q = $q
  }

  subscription(success, fail) {
    // atla/raven/gtw/whatever we call it don't have recurly accounts, so only
    // call if they don't have the raven role
    if (!this.CurrentUserService.hasUserRole("rav-u")) {
      return this.Subscription.get({userId: this.CurrentUserService.current.userId}, success, fail)
    }
  }

  updateSubscription(subscriptionPatch, success, fail) {
    return this.Subscription.update(
        {userId: this.CurrentUserService.current.userId},
        subscriptionPatch,
        success,
        fail)
  }

  updateSubscriptionPatch() {
    const currentSub = this.subscription().$promise
    const plans = this.plans().$promise
    const addOns = this._allAddOns()

    return this.$q.all({currentSub: currentSub, plans: plans, addOns: addOns})
  }

  plans(success, fail) {
    return this.Plans.get(success, fail)
  }

  addOns(plan, success, fail) {
    return this.AddOns.get({plan: plan}, success, fail)
  }

  _allAddOns() {
    return this.plans().$promise
      .then(this._addOnsForPlans.bind(this))
  }

  _addOnsForPlans(plans) {
    return _.reduce(plans.plans, (addOns, p) => {
      addOns[p] = this.AddOns.get({plan: p})
      return addOns
    }, {} )
  }

  datasets(success, fail) {
    return this.Datasets.get({userId: this.CurrentUserService.current.userId}, success, fail)
  }

  searchableStates() {
    return this.datasets().$promise.then((d) => {
      return _.uniq(_.map(d.datasets, (d) => d.state))
    })
  }
}

SubscriptionService.$inject = [
  'Subscription',
  'AddOns',
  'Plans',
  'Datasets',
  'CurrentUserService',
  '$q'
]

export default SubscriptionService
